export enum ExtendVMTimeStatusCodes {
  OK = 0,
  SUBSCRIBER_ONLY = 1,
  VM_EXPIRY_NOT_LESS_THAN_1HOUR = 2,
  VM_RUNNING_FOR_MORE_THAN_6HOURS = 3,
}
